import { ModuleParamGlobConfigService } from 'src/app/core/service/moduleFieldConfig/module-param-glob-config.service';

export class ModuleParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    title: {
      label: this.moduleParamConfigGlob.getLabel('partytype', 'title', 'Business Partner Type'),
    },
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('partytype', 'subtitle', 'Business Partner Type Details'),
    },
    basicDetail: {
      label: this.moduleParamConfigGlob.getLabel('partytype', 'basicDetail', 'Basic Details'),
    },
    name: {
      label: this.moduleParamConfigGlob.getLabel('partytype', 'name', 'Name'),
    },
    description: {
      label: this.moduleParamConfigGlob.getLabel('partytype', 'description', 'Description'),
      isVisible: this.moduleParamConfigGlob.isVisible('partytype', 'description'),
    },
    party_type: {
      label: this.moduleParamConfigGlob.getLabel('partytype', 'partyType', 'Party Type'),
    },
  };
}
